module.exports = __webpack_public_path__ + "img/CrossChainBridge_icon2.1c668aaf.svg";